// Pure helpers for the LinkedIn Page/Personal connect chooser.
//
// LinkedIn personal and Company Page posting use two SEPARATE OAuth providers
// (separate LinkedIn apps / scope sets) AND separate integration rows:
//   - personal → provider `linkedin`     (personal profile scopes)
//   - page     → provider `linkedin_org` (Community Management org scopes)
// They surface as a single "LinkedIn" card with this chooser, but each lands in
// its own integration row (the card reflects whichever is active). Keeping the
// "mode → provider" decision here (no React) makes it unit-testable without RTL.

export type LinkedInMode = 'personal' | 'page'

/** OAuth provider ids the chooser can initiate. */
export const LINKEDIN_PERSONAL_PROVIDER = 'linkedin'
export const LINKEDIN_ORG_PROVIDER = 'linkedin_org'

/**
 * The two choices surfaced in the connect chooser, in display order.
 */
export const LINKEDIN_CONNECT_OPTIONS: ReadonlyArray<{
  mode: LinkedInMode
  title: string
  description: string
}> = [
  {
    mode: 'personal',
    title: 'Personal profile',
    description: 'Publish to your own LinkedIn profile.',
  },
  {
    mode: 'page',
    title: 'Company Page',
    description: 'Publish to a LinkedIn Company Page you manage.',
  },
]

/**
 * Map a chosen mode to the OAuth provider id the popup should open.
 * `page` initiates the separate `linkedin_org` app (org-only scopes); every
 * other mode uses the default `linkedin` personal app.
 */
export function linkedinModeToProvider(mode: LinkedInMode): string {
  return mode === 'page' ? LINKEDIN_ORG_PROVIDER : LINKEDIN_PERSONAL_PROVIDER
}
